import { createSlice } from "@reduxjs/toolkit";

// Holds the logged-in user's permission payload and related notification data used
// across protected screens.
const permissionDataSlice = createSlice({
  name: "permissionData",
  initialState: {
    user: null,
    userPermissionData: null,
    notificationData: null,
  },

  reducers: {
    // Save the permission object returned after login or permission refresh.
    addUserPermissionData: (state, action) => {
      state.userPermissionData = action.payload;
    },
    // Keep notification data globally available for header and panel components.
    addNotificationData: (state, action) => {
      state.notificationData = action.payload;
    }
  },
});

export const { addUserPermissionData ,addNotificationData} = permissionDataSlice.actions;

export default permissionDataSlice.reducer;
